import type { Effect, Reducer, Subscription } from "@umijs/max";
import type { SingleBillType } from "./data";
import { getBillPage, queryBillStatus } from "./service";

export type BillState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleBillType[];
};

type BillModelType = {
  namespace: string;
  state: BillState;
  reducers: {
    BillReducer: Reducer<BillState>;
  };
  effects: {
    fetchBillPageEffect: Effect;
    refreshDataEffect: Effect;
    queryBillStatusEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: "refreshDataEffect",
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const BillModel: BillModelType = {
  namespace: "bill",
  state: {
    code: 0,
    type: "",
    message: "success",
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    BillReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as BillState;
    },
  },

  effects: {
    *fetchBillPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getBillPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: "BillReducer",
          payload: res,
        });
      } catch (e) {
        console.error("Fetch data failed:", e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.bill.current);
      const pageSize = yield select((state: any) => state.bill.pageSize);
      yield put({
        type: "fetchBillPageEffect",
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 简化的 effects
    queryBillStatusEffect: createEffect(queryBillStatus),
  },

  subscriptions: {
    setup() {},
  },
};

export default BillModel;
